// Subscribe KYC action widget — phase-aware wrapper around the
// existing KycStripeIdentity widget (Phase 7 Slice F).
//
// Mounted by content/subscribe/kyc.pre.md (default) and kyc.verified.md
// (with state=verified). Submitted-state markdown doesn't mount this
// widget — it's a callout-only template.

import { useNavigate } from 'react-router-dom';
import { Button } from '@rmint/ui';
import { KycStripeIdentity } from './kyc-stripe-identity';
import type { WidgetProps } from './registry';

export function SubscribeKycAction(props: WidgetProps) {
  const navigate = useNavigate();
  const subscriptionId = props.subscriptionId as string | undefined;
  const state = props.state as string | undefined;

  if (state === 'verified') {
    if (!subscriptionId) {
      return (
        <p className="text-sm text-warn">
          subscribe-kyc-action: missing <code className="font-mono">subscriptionId</code> prop.
        </p>
      );
    }
    return (
      <div className="flex justify-end">
        <Button
          variant="primary"
          size="lg"
          onClick={() => navigate(`/subscribe/${encodeURIComponent(subscriptionId)}/allocate`)}
        >
          Continue to Allocate →
        </Button>
      </div>
    );
  }

  // Default (pre-submission) — delegate to the existing Stripe widget.
  return <KycStripeIdentity {...props} />;
}
